/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function CostLaborEditCommandFromJSON(json) {
    return CostLaborEditCommandFromJSONTyped(json, false);
}
export function CostLaborEditCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'costId': !exists(json, 'costId') ? undefined : json['costId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'laborDate': !exists(json, 'laborDate') ? undefined : (json['laborDate'] === null ? null : new Date(json['laborDate'])),
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'laborName': !exists(json, 'laborName') ? undefined : json['laborName'],
        'laborRateMultiplier': !exists(json, 'laborRateMultiplier') ? undefined : json['laborRateMultiplier'],
        'laborHours': !exists(json, 'laborHours') ? undefined : json['laborHours'],
        'tcardRecordType': !exists(json, 'tcardRecordType') ? undefined : json['tcardRecordType'],
        'tcardNotes': !exists(json, 'tcardNotes') ? undefined : json['tcardNotes'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
    };
}
export function CostLaborEditCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'costId': value.costId,
        'workorderId': value.workorderId,
        'laborDate': value.laborDate === undefined ? undefined : (value.laborDate === null ? null : value.laborDate.toISOString()),
        'user': UserToJSON(value.user),
        'laborName': value.laborName,
        'laborRateMultiplier': value.laborRateMultiplier,
        'laborHours': value.laborHours,
        'tcardRecordType': value.tcardRecordType,
        'tcardNotes': value.tcardNotes,
        'orderNumber': value.orderNumber,
    };
}
